import { langId } from '../lang'
import { guessCountry } from './env'

const apiKey = 'AIzaSyAS08GNQDNdnjMcBQ2WThsyGv3ZAb7U6es'

export function createGoogleScriptElement($store) {
	const country = $store.state.country || guessCountry().idShort
	const googleApiScriptUrl =
		`https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=googleApisInited&libraries=places&language=` +
		langId +
		'&region=' +
		country

	let googleScript = document.createElement('script')
	googleScript.setAttribute('src', googleApiScriptUrl)
	return googleScript
}

let googleApiResolve = null
let googleApiPromise = new Promise(resolve => {
	googleApiResolve = resolve
})

export async function getGoogleApi() {
	return googleApiPromise
}

export let locationService = null
let placesService = null
window.googleApisInited = function(google) {
	locationService = new window.google.maps.places.AutocompleteService()

	let hiddenGoogleMapsElement = document.createElement('div')
	hiddenGoogleMapsElement.classList.add('hiddenGoogleMapsElement')
	this.document.body.appendChild(hiddenGoogleMapsElement)

	new window.google.maps.Map(hiddenGoogleMapsElement, {})
	placesService = new window.google.maps.places.PlacesService(hiddenGoogleMapsElement)

	googleApiResolve(google)
}

export const AUTOCOMPLETE_TYPE = {
	VENUE: 'establishment',
	ADDRESS: 'address',
	CITY: '[custom-cities]',
}

export async function autocompletePlace(
	query,
	autocompleteType,
	country,
	googleLocation, // new window.google.maps.LatLng(lat, lng)
	radius = 1000
) {
	await getGoogleApi()

	let type = autocompleteType
	const doCustomCityAutocomplete = autocompleteType === '[custom-cities]'
	if (doCustomCityAutocomplete) {
		// Try with geocode first. Read below for details.
		type = 'geocode'
	}

	let options = {
		input: query,
		types: [type],
		location: googleLocation,
		radius,
		// language: 'fi',
		componentRestrictions: {
			country,
		},
	}

	return new Promise(resolve => {
		locationService.getPlacePredictions(options, function(predictions, status) {
			if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
				console.warn('error getting prediction', status, options)
				return
			}

			// Do a little trick to better get municipalities.
			if (doCustomCityAutocomplete) {
				// let json = x => JSON.parse(JSON.stringify(x))
				// log('!!! geocode first results', json(predictions))

				predictions = predictions.filter(prediction => {
					// Geocode predictions return municipalities without a secondary text
					// and other locations with a secondary text. Use this knowledge to
					// filter only municipalities (or some other places, but that doesn't
					// hurt too much)
					if (prediction.structured_formatting.secondary_text) {
						// Likely not a city / municipality.
						return false
					}
					return true
				})

				// log('!!! geocode filtered results', json(predictions))
				if (predictions.length === 0) {
					// If none good predictions were found, try again with (cities), which is
					// inaccurate by itself but better than zero results
					options.types = ['(cities)']

					locationService.getPlacePredictions(options, function(predictions, status) {
						if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
							console.warn('error getting prediction', status, options)
							return
						}

						// log('!!! (cities) results', json(predictions))
						resolve(predictions)
						return
					})
				} else {
					resolve(predictions)
					return
				}
			} else {
				resolve(predictions)
			}
		})
	})
}

window.autocompletePlace = autocompletePlace

export async function getGooglePlaceDetails(placeId) {
	return new Promise(resolve => {
		const request = {
			placeId,
		}
		placesService.getDetails(request, resolve)
	})
}

export function createAddressFromGooglePlace(place) {
	function parse(type) {
		for (let component of place.address_components) {
			if (component.types.includes(type)) {
				return component.long_name
			}
		}
		return null
	}

	let parts = []
	parts.push(parse('route'))
	parts.push(parse('street_number'))
	parts.push(parse('subpremise'))

	parts = parts.filter(part => !!part)

	return parts.join(' ')
}

export function postalCodeFromGooglePlace(place) {
	const { address_components: addressComponents } = place
	const postCodeComponent = addressComponents.find(({ types }) => types.includes('postal_code'))
	return postCodeComponent ? postCodeComponent.long_name : ''
}
